import * as React from "react";
import { Provider } from "react-redux";
import "antd/dist/antd.css";
import "../styles/main.scss";
import AppRoutes from "../routes";
import { store } from "./store";

const App = () => {
  return (
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  );
};

export default App;
